// features/hive/ui/HiveChartSection/consts.ts
const marksColors = [
    {
        colorId: "1",
        colorBg: "--status-01-muted"
    },
    {
        colorId: "2",
        colorBg: "--status-02-muted"
    },
    {
        colorId: "3",
        colorBg: "--status-03-muted"
    },
    {
        colorId: "4",
        colorBg: "--status-04-muted"
    },
    {
        colorId: "5",
        colorBg: "--status-05-muted"
    },
    {
        colorId: "6",
        colorBg: "--status-06-muted"
    },
];

export { marksColors };
